/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  AfterViewChecked,
  ViewChild,
  ElementRef,
  HostListener
} from '@angular/core';

import { ChangedEvent } from '@typescript-kit/core';
import { TableModel, TableRowModel, TableColumnModel, TableCellModel } from '@typescript-kit/view';
import { BaseDirective } from '../../directive/base.directive';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'table[kitModel]',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableComponent extends BaseDirective<TableModel> implements AfterViewChecked {
  private _columnHeaderModels: TableRowModel[];
  private _rowHeaderModels: TableColumnModel[];
  private _rowModels: TableRowModel[];
  private _columnModels: TableColumnModel[];

  private scrollbarWith: number = 0;

  @ViewChild('headerElement') private headerElementRef: ElementRef;
  // @ViewChild('scrollbarOffset', { static: false }) private scrollbarOffsetElementRef: ElementRef;
  @ViewChild('bodyElement', { static: true }) private bodyElementRef: ElementRef;

  @HostListener('window:resize')
  onWindowResize() {
    this.refreshScrollbarWidth();
  }

  get hostClass(): string {
    return 'kit-table';
  }

  ngAfterViewChecked(): void {
    this.refreshScrollbarWidth();
  }

  get headerElement(): HTMLElement {
    return this.headerElementRef && this.headerElementRef.nativeElement;
  }

  // get scrollbarOffsetElement(): HTMLElement {
  //   return this.scrollbarOffsetElementRef.nativeElement;
  // }

  get bodyElement(): HTMLElement {
    return this.bodyElementRef.nativeElement;
  }

  get columnHeaderModels(): TableRowModel[] {
    return this._columnHeaderModels;
  }

  get rowHeaderModels(): TableColumnModel[] {
    return this._rowHeaderModels;
  }

  get rowModels(): TableRowModel[] {
    return this._rowModels;
  }

  get columnModels(): TableColumnModel[] {
    return this._columnModels;
  }

  getCell(row: TableRowModel, column: TableColumnModel): TableCellModel {
    const cell = this.model && this.model.getCell(row.index, column.index);
    return cell && !cell.isHidden ? cell : null;
  }

  getRowSpan(row: TableRowModel, column: TableColumnModel): number {
    const cell = this.getCell(row, column);
    return typeof cell.rowSpan === 'number' ? cell.rowSpan : 1;
  }

  protected onModelChanged(model: TableModel) {
    super.onModelChanged(model);
    this.refreshRows();
    this.refreshColumns();
  }

  protected onModelPropertyChanged(event: ChangedEvent): void {
    super.onModelPropertyChanged(event);
    this.refreshRows();
    this.refreshColumns();
  }

  private refreshScrollbarWidth() {
    if (!this.headerElement) {
      return;
    }
    // if (!this.scrollbarOffsetElement) {
    //   return;
    // }
    // const firstRow: Element = this.bodyElement.firstElementChild;
    // let scollbarWidth: number;
    // if (!firstRow) {
    //   scollbarWidth = 0;
    // } else {
    //   scollbarWidth = this.bodyElement.offsetWidth - firstRow.scrollWidth;
    // }

    const scollbarWidth = this.bodyElement.offsetWidth - this.bodyElement.clientWidth;
    if (this.scrollbarWith === scollbarWidth) {
      return;
    }
    this.scrollbarWith = scollbarWidth;
    this.headerElement.style.paddingRight = scollbarWidth > 0 ? `${scollbarWidth}px` : '0';
    // if (scollbarWidth > 0) {
    //   this.bodyElement.style.minWidth = `calc(100% + ${scollbarWidth}px)`;
    // }
    // this.scrollbarOffsetElement.style.width = scollbarWidth > 0 ? `${scollbarWidth}px` : '0';

    // use get boundin rectangle
    // const scollbarWidth = this.bodyElement.scrollWidth - this.bodyElement.clientWidth;
    // console.log('scollbarWidth', scollbarWidth);
  }

  private refreshRows() {
    if (!this.model) {
      this._columnHeaderModels = [];
      this._rowModels = [];
      return;
    }
    const headerRowCount = this.model.columnHeaderCount;
    if (!headerRowCount) {
      this._columnHeaderModels = [];
      this._rowModels = this.model.rowArray.filter((rowModel: TableRowModel) => !rowModel.isHidden);
      return;
    }
    this._columnHeaderModels = [];
    for (let i = 0; i < headerRowCount && i < this.model.rowArray.length; i++) {
      const rowModel = this.model.rowArray[i];
      if (!rowModel.isHidden) {
        this._columnHeaderModels.push(rowModel);
      }
    }
    this._rowModels = [];
    for (let i = headerRowCount; i < this.model.rowArray.length; i++) {
      const rowModel = this.model.rowArray[i];
      if (!rowModel.isHidden) {
        this._rowModels.push(rowModel);
      }
    }
  }

  private refreshColumns() {
    if (!this.model) {
      this._rowHeaderModels = [];
      this._columnModels = [];
      return;
    }
    const headerColumnCount = this.model.rowHeaderCount;
    if (!headerColumnCount) {
      this._rowHeaderModels = [];
      this._columnModels = this.model.columnArray.filter((columnModel) => !columnModel.isHidden);
      return;
    }
    this._rowHeaderModels = this.model.columnArray.slice(0, headerColumnCount).filter((columnModel) => !columnModel.isHidden);
    this._columnModels = this.model.columnArray.slice(headerColumnCount).filter((columnModel) => !columnModel.isHidden);
  }

}
